
import { Component, Vue, Watch } from 'vue-property-decorator';
// import { Route } from 'vue-router';

import axios from 'axios';
import moment from 'moment';

import { getCookie, setCookie } from 'tiny-cookie';
import appService from './app.service.ts';
import { getSubdomain, updateZendeskLocale } from '@/_helpers/utils.js';

import SetMetricsMixin from '@/mixins/setMetrics';

import NotFound from '@/components/NotFound.vue';
import ErrorModal from '@/components/modals/Error.vue';
import ModalRequestVacancies from '@/components/modals/ModalRequestVacancies';
import ModalCreateVacancy from '@/components/modals/ModalCreateVacancy';
import Informer from '@/components/informer.vue';

import injectComponentDependency from '@/_helpers/injector.js';

@Component({
  components: {
    NotFound,
    ErrorModal,
    ModalRequestVacancies,
    ModalCreateVacancy,
    Informer
  },
  mixins: [SetMetricsMixin]
})
export default class App extends Vue {
  $route: Route;
  $i18n: any;
  $tr: any;
  window: any;

  //data
  private localesLoaded: boolean = false;
  private showInformer: boolean = true;
  private enableShowCookieNotification: boolean = true;
  private cookieAccepted: any = null;
  // private showUpgradeUI: boolean = false;
  private localesFetched: boolean = false;

  // computed
  get notFound(): boolean {
    return this.$store.getters['page_status_code'] === 404;
  }

  get sitemessage(): any {
    return this.$store.getters['siteinformers/message'];
  }

  get requireAuthFinished(): boolean {
    return this.$store.getters['services/requireAuthFinished'];
  }

  get listLocales(): string[] {
    return this.$store.getters['services/listLocales'];
  }

  get locale(): string {
    return this.$store.getters['locale/current'];
  }

  get globalError(): any {
    return this.$store.getters['global/error'];
  }

  get globalErrorId(): any {
    return this.$store.getters['global/error_id'];
  }

  get processName(): string {
    return this.$store.getters['process/getName'];
  }

  get isShowCookieNotification(): boolean {
    if (!this.enableShowCookieNotification) {
      return false;
    }

    return this.cookieAccepted === null;
  }

  // get companySettings() {
  //   return this.$store.getters['admin_new/company/companySettings'];
  // }

  // watch
  @Watch('route')
  routeChanged(val: Route): void {
    if (val && val.name && val.name !== this.$router.name) {
      this.$router.replace(val);
    }
  }

  @Watch('$route', {
    immediate: true
  })
  $routeChanged(val: Route): void {
    appService.setDocumentTitle(val, this.$tr, this.$store);
  }

  @Watch('requireAuthFinished', {
    immediate: true
  })
  async requireAuthFinishedChanged(val: boolean, oldVal: boolean): void {
    if (val && !oldVal) {
      injectComponentDependency();

      if (!this.localesLoaded) {
        this.fetchLocales(this.locale);
      }
    }
  }

  @Watch('processName')
  processNameChanged(): void {
    injectComponentDependency();
  }

  @Watch('locale', {
    immediate: true
  })
  localeChanged(val, oldVal): void {
    this.localesLoaded = false;
    axios.defaults.headers.common['Accept-Language'] = val;
    moment.locale(val);

    if (!this.hasLocale(val)) {
      this.fetchLocales(val);
      return;
    }

    this.$i18n.locale = val;
    this.localesLoaded = true;

    appService.setDocumentTitle(this.$route, this.$tr, this.$store);
    // updateZendeskLocale();
  }

  @Watch('localesFetched', {
    immediate: true
  })
  localesLoadedChanged(val, oldVal): void {
    this.$store.commit('services/setLocalesLoaded', val);
  }

  //methods
  public fetchLocales(val: string) {
    if (this.hasLocale(val)) {
      return;
    }
    this.$store.commit('services/setListLocales', val);

    return this.$store
      .dispatch('services/get_locales', val)
      .then(res => {
        this.$i18n.setLocaleMessage(val, res.data.data[0]);
        window.$tr = this.$tr;
        // updateZendeskLocale();
        this.$i18n.locale = val;
        this.localesLoaded = true;
        this.localesFetched = true;
        appService.setDocumentTitle(this.$route, this.$tr, this.$store);
      })
      .catch(e => {
        this.localesLoaded = true;
      });
  }

  public hasLocale(val: string): boolean {
    return this.listLocales && this.listLocales.length
      ? !!this.listLocales.find(item => item === val)
      : false;
  }

  public clearGlobalError(): void {
    this.$store.commit('global/clearError');
  }

  public submitCookieNotification(): void {
    this.enableShowCookieNotification = false;

    setCookie('viewed_cookie_policy', 'yes', {
      domain: `.${getSubdomain()}`
    });
  }

  public checkCookies(): void {
    this.cookieAccepted = getCookie('viewed_cookie_policy');

    if (window.location.hostname === 'localhost') {
      this.cookieAccepted = 'yes';
    }
  }

  async accept() {
    // this.showUpgradeUI = false;
    // await this.$workbox.messageSW({ type: 'SKIP_WAITING' });
  }

  hideInformer() {
    this.showInformer = false;
  }

  async created() {
    // if (this.$workbox) {
    //   this.$workbox.addEventListener('waiting', () => {
    //     this.showUpgradeUI = true;
    //   });
    // }

    // First App Init
    // appInitInner нужно запускать только для маршрутов не Публичных. Все запросы используемые в этом методе должны использовать токены полученные при авторизации
    if (this.$route.meta.isOuter === undefined && !this.$route.meta.isOuter) {
      await this.$store.dispatch('appInit/appInitInner');
    }
  }

  mounted() {
    this.checkCookies();

    // appService.setVhProperty();
    appService.setCsrfTokenHeader();
  }
}
